import axios from 'axios';

const urlModel1 = 'data/metric-100D.json';
const urlModel2 = 'data/metric-P100D.json';


export const dataModels = [];

export const getData =  async () => {
  const fetchModel1 = axios.get(urlModel1);
  const fetchModel2 = axios.get(urlModel2);
  await axios.all([fetchModel1, fetchModel2])
  .then(axios.spread((...responses) => {
    dataModels.push(responses[0].data);
    dataModels.push(responses[1].data);
  })).catch(errors => {
    console.log(errors);
  });
};
